import { isBrowser } from "^/utils/isBrowser";

const livUrlsDe = [
  "https://www.liv-bib.de/",
  "https://hhn-liv-staging.justrelate.io/de",
  "https://hhn-liv.justrelate.io/de",
];
const livUrlsEn = [
  "https://www.liv-bib.de/en",
  "https://hhn-liv-staging.justrelate.io/en",
  "https://hhn-liv.justrelate.io/en",
];
const livUrlsEs = [
  "https://www.liv-bib.de/es",
  "https://hhn-liv-staging.justrelate.io/es",
  "https://hhn-liv.justrelate.io/es",
];
const LIVDE_SITE_ID = "62854995310d1623"; // german liv site_id
const LIVEN_SITE_ID = "8d9b3a5d4cd769ec"; // english liv site_id
const LIVES_SITE_ID = "5ea233e30e0ec9dd"; // spanish liv site_id

function siteForUrl(url) {
  // handle liv urls
  if (livUrlsEn.some((livUrl) => url.startsWith(livUrl))) {
    return { siteId: LIVEN_SITE_ID, baseUrl: baseUrlForSite(LIVEN_SITE_ID) };
  }
  if (livUrlsDe.some((livUrl) => url.startsWith(livUrl))) {
    return { siteId: LIVDE_SITE_ID, baseUrl: baseUrlForSite(LIVDE_SITE_ID) };
  }
  if (livUrlsEs.some((livUrl) => url.startsWith(livUrl))) {
    return { siteId: LIVES_SITE_ID, baseUrl: baseUrlForSite(LIVES_SITE_ID) };
  }

  let siteId;
  switch (new URL(url).pathname.split("/")[1]) {
    case "de":
      siteId = "de";
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    case "en":
      siteId = "en";
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    case "intranet":
      siteId = "intranet";
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    case "liv-de":
      siteId = LIVDE_SITE_ID;
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    case "liv-en":
      siteId = LIVEN_SITE_ID;
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    case "liv-es":
      siteId = LIVES_SITE_ID;
      return { siteId, baseUrl: baseUrlForSite(siteId) };
    default:
      siteId = "de";
      return { siteId, baseUrl: baseUrlForSite(siteId) };
  }
}

function baseUrlForSite(siteId) {
  // for prerender use default url
  const url = isBrowser
    ? window.location.origin
    : "https://www.hs-heilbronn.de";

  const isLocalhost = url.includes("localhost");

  switch (siteId) {
    case "de":
      return `${url}/de`;
    case "en":
      return `${url}/en`;
    case "intranet":
      return `${url}/intranet`;
    case LIVDE_SITE_ID:
      return isLocalhost ? `${url}/liv-de` : `${url}/de`;
    case LIVEN_SITE_ID:
      return isLocalhost ? `${url}/liv-en` : `${url}/en`;
    case LIVES_SITE_ID:
      return isLocalhost ? `${url}/liv-es` : `${url}/es`;
    default:
      return `${url}/de`;
  }
}

export { siteForUrl, baseUrlForSite };
